<template>
    <svg
        :class="'w-' + size + ' h-' + size"
        :width="size * 4"
        :height="size * 4"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <path d="M19 15L12 9L10.25 10.5M5 15L7.33333 13" />
    </svg>
</template>

<script>
export default {
    name: "IconAltUp",
    props: {
        size: {
            type: Number,
            default: 5,
        },
    },
};
</script>
